
import { DataBox, createDataBox } from 'app/common/data-box-store'


type TableSelectedItemsState = {
  items: Record<string, boolean>
  count: number
  checkedAll: boolean
}

const tableSelectedItemsStoreID = 'tableSelectedItemsStoreID'
const defaultState: TableSelectedItemsState = {
  items: {},
  count: 0,
  checkedAll: false,
}

class SelectedItemsDataBox extends DataBox<TableSelectedItemsState> {
  selectToggle = (ID: string) => {
    const newState = {
      ...this.data.items,
      [ID]: !this.data.items[ID],
    }
    const count = Object.values(newState).filter(value => value).length
    this.updateData(() => ({
      items: newState,
      count,
      checkedAll: count === Object.keys(newState).length,
    }))
  }

  addAllIDs = (IDs: Array<string>) => {
    const newState: Record<string, boolean> = {}
    IDs.forEach((ID) => {
      newState[ID] = false
    })
    this.updateData(() => ({
      items: newState,
      count: 0,
      checkedAll: false,
    }))
  }

  selectAllToggle = () => {
    const curStatus = this.data.checkedAll
    const newState = { ...this.data.items }
    const allIDs = Object.keys(newState)
    allIDs.forEach((ID) => {
      newState[ID] = !curStatus
    })

    this.updateData(() => ({
      items: newState,
      count: !curStatus ? allIDs.length : 0,
      checkedAll: !curStatus,
    }))
  }

  numberOfSelected = () => {
    return this.data.count
  }

  getAll = () => {
    return this.data
  }
}

export const tableSelectedItems = createDataBox(tableSelectedItemsStoreID, defaultState, SelectedItemsDataBox)
